const options = {
    SITE_URL: 'http://moonceramic.by:8000/'
}

export function site_options(state = options) {
    return state;
}
